const PreOrderFlag = () => (
  <div className="property-card-flag property-card-flag--pre-order" data-test-reference="pre-order-flag">
    <div className="property-card-flag--emphasized-text">PRE</div>
    <div>ORDER</div>
  </div>
);

export default PreOrderFlag;
